const prefix = "SSR_";

export class SsrConstants {
    public static IS_SSR: string = prefix + "IS_SSR";
}



// WEBPACK FOOTER //
// ./src/constants/ssr.ts